import React, { useRef } from 'react';
import { FeatureFlagProvider } from '@zep/feature-flag';
import { getDeviceId } from '@zep/session-id';
import { useUser } from '@/lib/auth';
import { FEATURE_FLAG_ENVIRONMENT, FEATURE_FLAG_NAMESPACE, FEATURE_FLAG_SERVER_URL } from '../constants/featureFlag';

/**
 * quiz-app 전용 FeatureFlagProvider wrapper.
 * next/dynamic으로 CSR-only 로드되어 @flipt-io/flipt-client-js WASM이
 * 서버/클라이언트 webpack 빌드에서 완전히 제외됩니다.
 *
 * entityId 결정 순서:
 * 1. user.quizUserId (로그인 시 — CSR에서 결정)
 * 2. ssrEntityId (SSR에서 전달된 entityId — 초기값으로 캡처)
 * 3. getDeviceId() (CSR에서 쿠키/localStorage 기반)
 *
 * ssrEntityId: getServerSideProps에서 세션 기반으로 결정한 entityId.
 * 로그인 유저의 경우 quizUserId를, 비로그인의 경우 deviceId를 전달할 수 있습니다.
 */
export default function QuizFeatureFlagProvider({
  children,
  ssrEntityId,
  ssrFlags,
  ssrVariants
}: {
  children: React.ReactNode;
  ssrEntityId?: string;
  ssrFlags?: Record<string, boolean>;
  ssrVariants?: Record<string, string>;
}) {
  const {
    user
  } = useUser();
  const deviceId = useRef(ssrEntityId || getDeviceId() || '').current;
  const userId = user?.quizUserId || '';
  return <FeatureFlagProvider serverUrl={FEATURE_FLAG_SERVER_URL} namespace={FEATURE_FLAG_NAMESPACE} environment={FEATURE_FLAG_ENVIRONMENT} userId={userId} deviceId={deviceId} ssrFlags={ssrFlags} ssrVariants={ssrVariants} data-sentry-element="FeatureFlagProvider" data-sentry-component="QuizFeatureFlagProvider" data-sentry-source-file="QuizFeatureFlagProvider.tsx">
      {children}
    </FeatureFlagProvider>;
}